import React from 'react'

function BranchPayment() {
  return (
    <div>BranchPayment</div>
  )
}

export default BranchPayment